<template>
  <div class="articles">
    <ArticlePreview :image="article.image"
                    :slug="article.slug"
                    :title="article.title"
                    :date="article.date"
                    :description="article.short_description"
                    v-for="article in articles"/>
  </div>
</template>

<script>
import ArticlePreview from "~/components/molecules/ArticlePreview.vue";

export default {
  components: {ArticlePreview},
  props: {
    articles: {
      type: Array,
    }
  }
}
</script>


<style scoped lang="scss">
.articles {
  display: grid;
  grid-gap: 50px;
  grid-auto-flow: row;
  padding-left: 0;
  grid-auto-columns: auto;
  grid-template-columns: repeat(3, 1fr);
  -moz-column-gap: 20px;
  column-gap: 50px;

  @include smd {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
